import { VERSION } from "lodash";

// Runtime configuration that works with both build-time and runtime env vars
const getRuntimeConfig = () => {
    // Check if runtime config is available (from EBS)
    if (typeof window !== 'undefined' && window.RUNTIME_CONFIG) {
        console.log('🚀 Using runtime configuration from EBS');
        return window.RUNTIME_CONFIG;
    }

    // Check if build config is available (from build-config.js)
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
        console.log('🔧 Using build-time configuration from APP_CONFIG');
        return window.APP_CONFIG;
    }

    // Check alternative build config name
    if (typeof window !== 'undefined' && window.BUILD_CONFIG) {
        console.log('🔧 Using build-time configuration from BUILD_CONFIG');
        return window.BUILD_CONFIG;
    }

    // Use webpack injected environment variables as fallback
    console.log('⚙️ Using webpack injected environment variables');
    const config = {
        SITE_TITLE: process.env.SITE_TITLE || process.env.REACT_APP_SITE_TITLE,
        ENVIRONMENT: process.env.ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT,
        ENVIRONMENT_URL: process.env.ENVIRONMENT_URL || process.env.REACT_APP_ENVIRONMENT_URL,
        API_ENDPOINT: process.env.API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT,
        API_ENDPOINT_V3: process.env.API_ENDPOINT_V3 || process.env.REACT_APP_API_ENDPOINT_V3,
        INGEST_ENDPOINT: process.env.INGEST_ENDPOINT || process.env.REACT_APP_INGEST_POINT,
        AWS_REGION: process.env.AWS_REGION || process.env.REACT_APP_REGION,
        AWS_USER_POOL: process.env.AWS_USER_POOL || process.env.REACT_APP_USER_POOL,
        AWS_APP_CLIENT: process.env.AWS_APP_CLIENT || process.env.REACT_APP_WEB_CLIENT,
        AWS_IDENTITY_POOL: process.env.AWS_IDENTITY_POOL || process.env.REACT_APP_IDENTITY_POOL,
        AUTH_TYPE: process.env.AUTH_TYPE || process.env.REACT_APP_AUTH_TYPE,
        API: process.env.API || process.env.REACT_APP_API,
        FAVICON: process.env.FAVICON || process.env.REACT_APP_FAVICON,
        POSTHOG_KEY: process.env.POSTHOG_KEY || process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
        POSTHOG_HOST: process.env.POSTHOG_HOST || process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        REACT_APP_DD_SITE: process.env.REACT_APP_DD_SITE,
        REACT_APP_DD_CLIENT_TOKEN: process.env.REACT_APP_DD_CLIENT_TOKEN,
        DD_RUM_APP_ID: process.env.REACT_APP_DD_RUM_APP_ID,
        DD_RUM_CLIENT_TOKEN: process.env.REACT_APP_DD_RUM_CLIENT_TOKEN,
        IMS_ICN_WALLOFTEXT: process.env.IMS_ICN_WALLOFTEXT || process.env.WALL_OF_TEXT_ICN || "https://ims-api.purplewave.com/v2/items/icn",
        IMS_ITEM_ID_WALLOFTEXT: process.env.IMS_ITEM_ID_WALLOFTEXT || process.env.WALL_OF_TEXT_ITEM || "https://ims-api.purplewave.com/v2/items",
         
        // Build metadata
        BUILD_VERSION: process.env.BUILD_VERSION || require('../../package.json').version,
        BUILD_TIME: process.env.BUILD_TIME,
        BUILD_COMMIT: process.env.BUILD_COMMIT,
        BUILD_ENVIRONMENT: process.env.BUILD_ENVIRONMENT,
        CONFIG_SOURCE: process.env.CONFIG_SOURCE || 'env-files'
    };

    // console.log('🔍 Config source determined:', {
    //     AWS_USER_POOL: config.AWS_USER_POOL ? '✅ Set' : '❌ Missing',
    //     AWS_APP_CLIENT: config.AWS_APP_CLIENT ? '✅ Set' : '❌ Missing',
    //     API_ENDPOINT: config.API_ENDPOINT ? '✅ Set' : '❌ Missing',
    //     SITE_TITLE: config.SITE_TITLE ? '✅ Set' : '❌ Missing'
    // });

    return config;
};

export const config = getRuntimeConfig();
export default config;
